<div  class="caremoni-radio-button" [attr.dpad]="dpad"
  [style.--scale-dpad]="scaledpad"
  [attr.x-dpad]="xdpad" 
  [attr.y-dpad]="ydpad" 
  [attr.tab-dpad]="tabdpad"
  [attr.x-tab-dpad]="xtabdpad" 
  [attr.y-tab-dpad]="ytabdpad" 
   (click)="handleClick($event)" [ngClass]="styleClass" [ngStyle]="style">
    <div class="radio-outer-circle" [ngClass]="{'button-container-checked': isChecked, 'radio-disable' : disabled }"></div>
    <div class="radio-inner-circle" [ngClass]="{'radio-disable' : disabled }" *ngIf="isChecked"></div>
</div>